import { SALON_API_PREFIX } from './apiConfig';
import { fetchWithTimeout } from './fetchWithTimeout';

function coerceNumericId(...candidates) {
  for (const raw of candidates) {
    if (raw == null || raw === '') continue;
    const id = Number(raw);
    if (Number.isFinite(id) && id > 0) return id;
  }
  return null;
}

export function buildProductCartPayload(items) {
  return Object.entries(items || {})
    .filter(([, item]) => item && Number(item.quantity) > 0)
    .map(([cartKey, item]) => {
      const id = coerceNumericId(item?.product?.id, item?.product?.product_id, cartKey);
      if (id == null) return null;
      return { id, quantity: Number(item.quantity) || 1 };
    })
    .filter(Boolean);
}

export function buildTreatmentCartPayload(items) {
  return Object.entries(items || {})
    .filter(([, item]) => item && Number(item.quantity) > 0)
    .map(([cartKey, item]) => {
      const id = coerceNumericId(item?.treatment?.id, item?.treatment?.treatment_id, cartKey);
      if (id == null) return null;
      return { id, quantity: Number(item.quantity) || 1 };
    })
    .filter(Boolean);
}

export function persistProductCart(apiBaseUrl, sessionId, token, items) {
  const baseUrl = (apiBaseUrl || '').replace(/\/$/, '');
  if (!baseUrl || !sessionId) return Promise.resolve(null);
  const cart_products = buildProductCartPayload(items);
  return fetchWithTimeout(`${baseUrl}${SALON_API_PREFIX}/save-cart-products`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      skin_id: sessionId,
      session_id: sessionId,
      ...(token && { app_session_token: token }),
      cart_products,
    }),
    timeoutMs: 20000,
  }).catch(() => null);
}

export function persistTreatmentCart(apiBaseUrl, sessionId, token, items) {
  const baseUrl = (apiBaseUrl || '').replace(/\/$/, '');
  if (!baseUrl || !sessionId) return Promise.resolve(null);
  const cart_treatments = buildTreatmentCartPayload(items);
  return fetchWithTimeout(`${baseUrl}${SALON_API_PREFIX}/save-cart-treatments`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      skin_id: sessionId,
      session_id: sessionId,
      ...(token && { app_session_token: token }),
      cart_treatments,
    }),
    timeoutMs: 20000,
  }).catch(() => null);
}
